import {
  styled,
  Box,
  ButtonBase,
  Typography,
  avatarClasses,
} from '@mui/material';

const MAX_WIDTH_LABEL_INFO = 180;

export const TrackingInTransitDeliveriesListContainer = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'relative',
    gap: theme.spacing(0.5),

    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: `calc(${MAX_WIDTH_LABEL_INFO}px + ${theme.spacing(0.75)})`,
      width: '1px',
      backgroundColor: theme.palette.action.disabled,
    },
  }),
);

export const TrackingInTransitDeliveriesListItemButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected: boolean }>(({ theme, isSelected }) => ({
  ...theme.typography.caption,
  lineHeight: 'normal',
  alignItems: 'center',
  padding: theme.spacing(0.75),
  borderRadius: theme.shape.borderRadius,
  justifyContent: 'flex-start',
  textAlign: 'left',

  '&:hover': {
    backgroundColor: theme.palette.action.focus,
  },

  ...(isSelected && {
    backgroundColor: theme.palette.action.selected,
  }),

  [`& .${avatarClasses.root}, & svg`]: {
    width: 20,
    height: 20,
  },
}));

export const TrackingInTransitDeliveriesListItemButtonInfo = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    alignItems: 'center',
    width: '100%',
    maxWidth: MAX_WIDTH_LABEL_INFO,
  }),
);

export const TrackingInTransitDeliveriesListItemButtonInfoText = styled(
  Typography,
)({
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  display: '-webkit-box',
  whiteSpace: 'normal',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const TrackingInTransitDeliveriesListItemButtonProgressContainer =
  styled(Box)({
    display: 'flex',
    width: '100%',
  });
